<template>
  <div class="content">
    <card class="text-left">
      <div class="row">
        <div v-for="image in images" class="col-sm-3">
          <img :src="image" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          {{ text }}
        </div>
      </div>
    </card>
    <card class="text-left">
      <div class="row">
        <label class="col-sm-2 col-form-label">게시글 ID</label>
        <div class="col-sm-3">
          <base-input>
            <p class="form-control-static">{{ contentId }}</p>
          </base-input>
        </div>
        <base-button class="update-button col-sm-3" @click.prevent="goHomepageUrl" type="confirm">웹페이지</base-button>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">작성자</label>

        <label class="col-md-10 col-form-label value"
          ><a class="pointer" @click="goUserDetail(userId)">{{ nickname }}({{ userId }})</a></label
        >
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">작성일자</label>

        <label class="col-md-10 col-form-label value">{{ regTime }}</label>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">노출 상태</label>

        <label class="col-md-10 col-form-label value">{{ stateName }}</label>
      </div>
    </card>
    <div class="row actions">
      <!-- <div v-if="state !== -1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="deleteContent" type="success">삭제</base-button>
      </div> -->
      <div v-if="state !== 0" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="hideContent" type="success">숨김</base-button>
      </div>
      <div v-if="state !== 1" class="col-md-2">
        <base-button class="col-md-12" @click="showContent" type="success">노출</base-button>
      </div>
      <div class="col-md-2">
        <base-button class="col-md-12" @click="onClickComments" type="success">댓글 보기</base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import swal from "sweetalert2";
import { formatDateTime } from "@/util/DateUtils";
import Endpoints from "@/common/Endpoints";

export default {
  components: {
    BaseInput,
    Card,
  },
  async created() {
    if (!this.$route.query.id) {
      Toast.error("잘못된접근입니다");
      history.go(-1);
    }

    this.contentId = Number(this.$route.query.id);
    await this.getContentDetail();
  },
  data() {
    return {
      text: null,
      fileIds: [],
      images: [],
      contentId: null,
      userId: null,
      nickname: null,
      state: null,
      regTime: null,
    };
  },

  methods: {
    async getContentDetail() {
      await this.$axios.get(`/homepage/community/${this.contentId}`).then((res) => {
        const data = res.data.data;
        this.userId = data.userId;
        this.contentId = data.id;
        this.userId = data.userId;
        this.nickname = data.nickname;
        this.state = data.deleteAt ? -1 : data.visibility;
        this.stateName = data.deleteAt ? "삭제" : data.visibility ? "노출" : "숨김";
        this.regTime = formatDateTime(data.regTime);
        this.text = data.text;
        if (data.imageIds) {
          this.fileIds = data.imageIds.split(",");
          this.images = this.fileIds.map((fileId) => `${Endpoints.imageServerUrl}${fileId}`);
        }
      });
    },

    async deleteContent() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.contentId} 게시글을 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/homepage/community/${this.contentId}/state`, {
                  params: { state: -1 },
                })
                .then((res) => {
                  Toast.success("게시글이 삭제 되었습니다");
                  this.state = -1;
                });
            } catch (err) {
              Toast.error("게시글 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async hideContent() {
      swal
        .fire({
          title: "숨김 확인",
          text: `${this.contentId} 게시글을 숨김 처리 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/homepage/community/${this.contentId}/state`, {
                  params: { unitId: this.unitId, state: 0 },
                })
                .then((res) => {
                  Toast.success("게시글이 숨김 되었습니다");
                  this.state = 0;
                });
            } catch (err) {
              Toast.error("게시글 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async showContent() {
      swal
        .fire({
          title: "노출 확인",
          text: `${this.contentId} 게시글을 다시 노출 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "노출",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/homepage/community/${this.contentId}/state`, {
                  params: { state: 1 },
                })
                .then(() => {
                  Toast.success("게시글이 노출 되었습니다");
                  this.state = 1;
                });
            } catch (err) {
              Toast.error("게시글 노출 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    goHomepageUrl() {
      window.open(`${Endpoints.homepageUrl}/community/${this.contentId}`);
    },
    onClickComments() {
      this.$router.push(`/homepage/community/comment?contentId=${this.contentId}`);
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.actions {
  margin-bottom: 40px;
}

.pointer {
  cursor: pointer;
}
</style>
